import { combineReducers } from 'redux';
import { kycsFields } from './kycs/kycs';
import { offersFields } from './offers/offers';
import { recipientFields } from './recipient/recipient';
import { senderFields } from './sender/sender';

export const fields = combineReducers({
  kycs: kycsFields,
  offers: offersFields,
  recipient: recipientFields,
  sender: senderFields,
});
